import {createContext} from 'react';

const comprensionContext = createContext();

export default comprensionContext;